export const TEST_STATUS_RUNNING = 'Running';
export const TEST_STATUS_DISABLED = 'Disabled';
export const TEST_STATUS_DELETED = 'Deleted';

export const SEM_FIELD = 'beaconPackets';
export const NAME_FIELD = 'name';
export const TAGS_FIELD = 'tags';
export const TEST_STATUS_FIELD = 'status';
